import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const studiesQuery = createApi({
  baseQuery,
  reducerPath: "studiesQueries",
  endpoints: (builder) => ({
    createStudy: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.studies.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    getAllStudies: builder.mutation<any, any>({
      query: ({
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        is_audit = false,
        data,
      }) => ({
        url: `${formatString(
          endPoints.studies.getAll
        )}?from=${from}&size=${size}&is_audit=${is_audit}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    updateStudy: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.studies.update)}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteStudy: builder.mutation<any, any>({
      query: ({ study_id }) => ({
        url: `${formatString(endPoints.studies.delete, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id),
        })}`,
        method: "DELETE",
      }),
    }),
    studyDetails: builder.query<any, any>({
      query: ({ study_id, is_audit = false }) => ({
        url: `${formatString(endPoints.studies.select, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id),
        })}?is_audit=${is_audit}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateStudyMutation,
  useGetAllStudiesMutation,
  useUpdateStudyMutation,
  useDeleteStudyMutation,
  useLazyStudyDetailsQuery,
} = studiesQuery;
